import "@babel/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';

// styles
import './index.css';
// components
import App from './components/App';

// service workerを登録する仕組
import registerServiceWorker from './registerServiceWorker';

import { CookiesProvider } from 'react-cookie'

ReactDOM.render(
    <CookiesProvider>
        <App />
    </CookiesProvider>
    ,document.querySelector('#root')
);

registerServiceWorker();